import confirm from '../../../utils/confirm.jsx';
import addError from '../../../utils/error.jsx';

export function request(id, days) {
    id = parseInt(id, 10);
    days = parseInt(days, 10);

    return confirm('Are you sure that you want to set play break for ' + days + ' days?', {
        type: 'CUSTOMERS_PLAY_BREAK_REQUEST',
        days,
        id
    });
}

export function error(id, errors) {
    id = parseInt(id, 10);

    addError(errors);

    return {
        type: 'CUSTOMERS_PLAY_BREAK_ERROR',
        errors,
        id
    };
}

export function finish(id, customer) {
    return {
        type: 'CUSTOMERS_PLAY_BREAK_FINISH',
        customer,
        id
    };
}

export function clear() {
    return {
        type: 'CUSTOMERS_PLAY_BREAK_CLEAR'
    };
}
